import React from 'react';
import styles from './Section3.module.scss';

const Section3 = () => {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.contentContainer}`}>
        <div className={`${styles.heading}`}>Rules and regulations</div>
        <div className={`${styles.body}`}>
          <div className={`${styles.rulesContainer}`}>
            <div className={`${styles.rulesTitle}`}>
              Join our daily pod challenge and stand a chance to win vouchers worth Rs. 500 every Monday, Wednesday, and
              Friday.
            </div>
            <div className={`${styles.rulesTitle} ${styles.rulesTitle2}`}>Rules:</div>
            <ol style={{ listStyleType: 'initial' }} className={`${styles.rulesPointsContainer}`}>
              <li>Creators must be above 18 years to be eligible for rewards</li>
              <li>Every creator/user has to use the given hashtag in their pods</li>
              <li>Creators should create a minimum of 1 pod each day with the challenge hashtag.</li>
              <li>
                Every creator has to have the minimum engagement metrics below to qualify
                <ol style={{ listStyleType: 'lower-alpha' }} className={`${styles.subPoint}`}>
                  <li>Play-count: 10 plays,</li>
                  <li>Likes: 5 likes,</li>
                  <li>Comments: 3 comments.</li>
                </ol>
              </li>
            </ol>
          </div>
          {/* not required for now */}
          {/* <div className={`${styles.voiceClubContainer}`}>
            <img
              className={`${styles.boxIllustration}`}
              src={'/assets/images/box.png'}
              alt="Box Illustration"
              loading="lazy"
            />
            <img
              className={`${styles.voiceClubDps}`}
              src={'https://asset.arredigital.co/Arr%C3%A9+Voice+Fest/images/section/voiceClubDps.png'}
              alt="Rewards Illustration"
              loading="lazy"
            />
            <div className={`${styles.voiceClubTitle}`}>
              <div>Voice Streak Club</div>
              <img
                className={`${styles.starIllustration}`}
                src={'/assets/images/star.png'}
                alt="Star Illustration"
                loading="lazy"
              />
            </div>
            <ol style={{ listStyleType: 'number' }} className={`${styles.voiceClubPointsContainer}`}>
              <li>
                What should I do?
                <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                  <li>
                    Create 4 pods for 4 days in a row in one week to win your first streak and join our exclusive Voice
                    Streak Club
                  </li>
                </ol>
              </li>
              <li>
                What will I get?
                <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                  <li>Sneak Peak of Next Day’s Challenge </li>
                  <li>First to access brand campaigns and deals, and Arré tote bag.</li>
                  <li>Also get a chance to feature on Arré’s social media channels.</li>
                  <li>Collect Maximum Streaks in the month and Win a Mega Surprise Gift</li>
                </ol>
              </li>
            </ol>
          </div> */}
          <div className={`${styles.tncLink}`}>
            <a href="/fest/terms-and-conditions" target={'_self'} rel={'noreferrer'} className="hover:underline">
              Read the full T&C.
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
